import PropTypes from "prop-types";

import Snackbar from "@material-ui/core/Snackbar";
import Slide from "@material-ui/core/Slide";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import makeStyles from "@material-ui/core/styles/makeStyles";

import reactChildrenType from "common/proptypes/react-children.proptypes";
import { toastStyles } from "common/context/toast/toast-styles";

const useStyles = makeStyles(toastStyles);

function SlideTransition(props) {
  return (
    <Slide
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      direction="left"
    />
  );
}

export function Toast({
  isOpen,
  onClose,
  children = null,
  type = "normal",
  message = "",
}) {
  const classes = useStyles();

  function handleClose(e, reason) {
    if (reason !== "clickaway") {
      onClose(e);
    }
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={5000}
      open={isOpen}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
    >
      <div className={classes[type]}>
        {children ?? <SnackbarContent message={message} />}
      </div>
    </Snackbar>
  );
}

Toast.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: reactChildrenType,
  type: PropTypes.oneOf(["error", "warning", "success", "normal"]),
  message: PropTypes.string,
};
